/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPDISINVESTMENTTYPE } from './IAPDISINVESTMENTTYPE';
import {
    IAPDISINVESTMENTTYPEFromJSON,
    IAPDISINVESTMENTTYPEFromJSONTyped,
    IAPDISINVESTMENTTYPEToJSON,
} from './IAPDISINVESTMENTTYPE';
import type { IAPYESORNO } from './IAPYESORNO';
import {
    IAPYESORNOFromJSON,
    IAPYESORNOFromJSONTyped,
    IAPYESORNOToJSON,
} from './IAPYESORNO';
import type { InvestmentDetailsJustIncomeAssetSplitViewModel } from './InvestmentDetailsJustIncomeAssetSplitViewModel';
import {
    InvestmentDetailsJustIncomeAssetSplitViewModelFromJSON,
    InvestmentDetailsJustIncomeAssetSplitViewModelFromJSONTyped,
    InvestmentDetailsJustIncomeAssetSplitViewModelToJSON,
} from './InvestmentDetailsJustIncomeAssetSplitViewModel';

/**
 * 
 * @export
 * @interface InvestmentDetailsJustPortfolioViewModel
 */
export interface InvestmentDetailsJustPortfolioViewModel {
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsJustPortfolioViewModel
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsJustPortfolioViewModel
     */
    productId?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsJustPortfolioViewModel
     */
    cashAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsJustPortfolioViewModel
     */
    unitAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsJustPortfolioViewModel
     */
    assetCode?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsJustPortfolioViewModel
     */
    incomeAmount?: number;
    /**
     * 
     * @type {IAPYESORNO}
     * @memberof InvestmentDetailsJustPortfolioViewModel
     */
    spousalInd?: IAPYESORNO;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsJustPortfolioViewModel
     */
    spousalPerc?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsJustPortfolioViewModel
     */
    minInvestmentPeriod?: number;
    /**
     * 
     * @type {string}
     * @memberof InvestmentDetailsJustPortfolioViewModel
     */
    quoteNumber?: string;
    /**
     * 
     * @type {IAPDISINVESTMENTTYPE}
     * @memberof InvestmentDetailsJustPortfolioViewModel
     */
    disinvestmentTypeId?: IAPDISINVESTMENTTYPE;
    /**
     * 
     * @type {Array<InvestmentDetailsJustIncomeAssetSplitViewModel>}
     * @memberof InvestmentDetailsJustPortfolioViewModel
     */
    justIncomeAssetSplits?: Array<InvestmentDetailsJustIncomeAssetSplitViewModel>;
}

/**
 * Check if a given object implements the InvestmentDetailsJustPortfolioViewModel interface.
 */
export function instanceOfInvestmentDetailsJustPortfolioViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InvestmentDetailsJustPortfolioViewModelFromJSON(json: any): InvestmentDetailsJustPortfolioViewModel {
    return InvestmentDetailsJustPortfolioViewModelFromJSONTyped(json, false);
}

export function InvestmentDetailsJustPortfolioViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvestmentDetailsJustPortfolioViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'Id') ? undefined : json['Id'],
        'productId': !exists(json, 'ProductId') ? undefined : json['ProductId'],
        'cashAmount': !exists(json, 'CashAmount') ? undefined : json['CashAmount'],
        'unitAmount': !exists(json, 'UnitAmount') ? undefined : json['UnitAmount'],
        'assetCode': !exists(json, 'AssetCode') ? undefined : json['AssetCode'],
        'incomeAmount': !exists(json, 'IncomeAmount') ? undefined : json['IncomeAmount'],
        'spousalInd': !exists(json, 'SpousalInd') ? undefined : IAPYESORNOFromJSON(json['SpousalInd']),
        'spousalPerc': !exists(json, 'SpousalPerc') ? undefined : json['SpousalPerc'],
        'minInvestmentPeriod': !exists(json, 'MinInvestmentPeriod') ? undefined : json['MinInvestmentPeriod'],
        'quoteNumber': !exists(json, 'QuoteNumber') ? undefined : json['QuoteNumber'],
        'disinvestmentTypeId': !exists(json, 'DisinvestmentTypeId') ? undefined : IAPDISINVESTMENTTYPEFromJSON(json['DisinvestmentTypeId']),
        'justIncomeAssetSplits': !exists(json, 'JustIncomeAssetSplits') ? undefined : ((json['JustIncomeAssetSplits'] as Array<any>).map(InvestmentDetailsJustIncomeAssetSplitViewModelFromJSON)),
    };
}

export function InvestmentDetailsJustPortfolioViewModelToJSON(value?: InvestmentDetailsJustPortfolioViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'ProductId': value.productId,
        'CashAmount': value.cashAmount,
        'UnitAmount': value.unitAmount,
        'AssetCode': value.assetCode,
        'IncomeAmount': value.incomeAmount,
        'SpousalInd': IAPYESORNOToJSON(value.spousalInd),
        'SpousalPerc': value.spousalPerc,
        'MinInvestmentPeriod': value.minInvestmentPeriod,
        'QuoteNumber': value.quoteNumber,
        'DisinvestmentTypeId': IAPDISINVESTMENTTYPEToJSON(value.disinvestmentTypeId),
        'JustIncomeAssetSplits': value.justIncomeAssetSplits === undefined ? undefined : ((value.justIncomeAssetSplits as Array<any>).map(InvestmentDetailsJustIncomeAssetSplitViewModelToJSON)),
    };
}

